<template>
    <!-- <div
        class=""
        :class="{ 'whitebg-navbar': showWhiteBg, 'show-navbar': showNavbar, 'show-menu': showMenu }"
    > -->
    <div class="container" id="top">
        <div
            v-if="showTopTopBtn"
            style="position:fixed; right:16px; bottom:32px; width:48px; height:48px; z-index:9; border-radius:12px; border:1px solid rgba(127,127,127,.15); background:rgba(255,255,255,.88);"
            class="tertiary-bg"
        >
            <div class="icon-48 inline-active" @click="scrollTo('top')">
                <i class="iconfont icon-to-top"></i>
            </div>
        </div>

        <qrcode :showQrcode="showQrcode" :toggleQrcode="toggleQrcode" />
        <navbar
            immersive="true"
            :toggleQrcode="toggleQrcode"
            :scrollTo="scrollTo"
            :scrollTop="scrollTop"
            :direction="direction"
            :activeNav="activeNav"
        />

        <div>
            <focus />
        </div>
		<div  ref="a" id="a">
		    <number />
		</div>
		<!-- 应用场景 -->
       <div ref="b" id="b">
           <content3d />
       </div>
	  
		<!-- 基础功能 -->
		<div ref="c" id="c">
		    <gameintro />
		</div>

		<!-- 自选 -->
	<div ref="d" id="d">
	    <zxservice />
	</div>
	<div ref="e" id="e">
	    <shopintro />
	</div>
 

 
 <!-- 合作企业 -->
        <div ref="f" id="f">
            <company />
        </div>
<!-- 联系我们 -->
        <div ref="g" id="g">
            <contact :toggleQrcode="toggleQrcode" />
        </div>

    </div>
</template>

<script>
import navbar from './components/navbar';
import focus from './components/focus';
// import newservice from './components/newservice';
// import hardware from './components/hardware';
import content3d from './components/content3d';
// import servicecase from './components/servicecase';
import contact from './components/contact';
import qrcode from './components/qrcode';
import company from './components/company';
import shopintro from './components/shopintro';
import zxservice from './components/zxservice';
import gameintro from './components/gameintro.vue';
import number from './components/number.vue';
export default {
    name: 'Home',

    components: {
        navbar,
        focus,
		number,
        // hardware,
        content3d,
        // servicecase,
		zxservice,
        contact,
        qrcode,
        company,
		shopintro,
		gameintro
        // newservice,
		// businesscase,
    },

    data() {
        return {
            aOffsetTop: 0,
            bOffsetTop: 0,
            cOffsetTop: 0,
            dOffsetTop: 0,
            eOffsetTop: 0,
            fOffsetTop: 0,
            gOffsetTop: 0,
			
            showQrcode: false,

            tempScrollTop: 0,
            scrollTop: 0,
            direction: '',
            activeNav: 'home',
        };
    },

    computed: {
        showTopTopBtn() {
            return this.scrollTop > 560;
        },
    },

    mounted() {
        window.addEventListener('scroll', this.handleScroll, true);
    },

    methods: {
        scrollToTop() {},

        scrollTo(p) {
            const options = {
                container: 'body',
                easing: 'ease-in',
                lazy: false,
                offset: -60,
                force: true,
                cancelable: true,
                onStart(element) {
                    // scrolling started
                },
                onDone(element) {
                    // scrolling is done
                },
                onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true,
            };
			if(p == "h"){
				  window.location.assign('https://admin.xiliji365.com/app/admin')
				  return;
			}
			if(p == "a"){
			 
				  return;
			}
            this.$scrollTo(`#${p.toLowerCase()}`, 400, options);
        },

        handleScroll(e) {
	 
            this.aOffsetTop = this.$refs.a.offsetTop;
            this.bOffsetTop = this.$refs.b.offsetTop;
            this.dOffsetTop = this.$refs.d.offsetTop;
            this.eOffsetTop = this.$refs.e.offsetTop;
            this.fOffsetTop = this.$refs.f.offsetTop;
            this.gOffsetTop = this.$refs.g.offsetTop;
		
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

            const scroll = this.scrollTop - this.tempScrollTop;
            this.tempScrollTop = this.scrollTop;
            if (scroll < 0) {
                this.direction = 'down';
            } else if (scroll > 0) {
                this.direction = 'up';
            }

            const navBarHeight = 72;
            if (this.scrollTop >= 0 && this.scrollTop < this.bOffsetTop - navBarHeight) {
                this.activeNav = 'home';
            } else if (
                this.scrollTop >= this.bOffsetTop - navBarHeight
                && this.scrollTop < this.cOffsetTop - navBarHeight
            ) {
                this.activeNav = 'content3d';
            } else if (
                this.scrollTop >= this.cOffsetTop - navBarHeight
                && this.scrollTop < this.dOffsetTop - navBarHeight
            ) {
                this.activeNav = 'gameintro';
    
            } else if (
                this.scrollTop >= this.dOffsetTop - navBarHeight
                && this.scrollTop < this.eOffsetTop - navBarHeight
            ) {
                this.activeNav = 'zxservice';
            } else if (this.scrollTop >= this.eOffsetTop - navBarHeight
			&& this.scrollTop < this.fOffsetTop - navBarHeight) {
				     this.activeNav = 'shopintro';
			} else if (
                this.scrollTop >= this.fOffsetTop - navBarHeight
                && this.scrollTop < this.gOffsetTop + navBarHeight
            ) {
                this.activeNav = 'company';
            } else if (
                this.scrollTop >= this.gOffsetTop + navBarHeight) {
                this.activeNav = 'contact';
            }else{
				
			}
        },

        toggleQrcode() {
            this.showQrcode = !this.showQrcode;
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all.scss';
</style>
